<template>
  <div class="page-wrapper">
    <Loader v-if="loading" />
    <div v-else>
      <ads-horizontal />
      <div class="profile-wrapper">
        <aside class="profile-sidebar-wrapper">
          <sidebar :sidebar-info="sidebarInfo" />
        </aside>
        <main class="profile-content-wrapper">
          <whats-hopping-new :value="topic" @send-topic="sendTopic" />
          <transition name="fade" mode="out-in" @after-enter="innerScroll">
            <router-view id="content-view-inner" v-slot:btn-back>
              <button-back @back="goBack" />
            </router-view>
          </transition>
        </main>
        <div class="profile-ads-wrapper">
          <ads-vertical />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader";
import Sidebar from "@/profiles/components/ProfileSidebar"
import WhatsHoppingNew from "../../components/WhatsHoppingNew"
import { ProfileService } from "@/profiles/services/profiles"
import AdsHorizontal from "@/profiles/components/AdsHorizontal";
import AdsVertical from "@/profiles/components/AdsVertical";
import { urldecode } from "@/services/helpers";
import ButtonBack from "@/profiles/components/ButtonBack";

export default {
  name: "Home",

  components: {
    ButtonBack,
    AdsVertical,
    AdsHorizontal,
    WhatsHoppingNew,
    Sidebar,
    Loader
  },

  data() {
    return {
      sidebarInfo: {},
      topic: '',
      loading: true
    }
  },

  watch: {
    sidebarInfo: {
      handler: function() {
        this.loading = false
      },
      deep: true
    }
  },

  async created() {
    const data = await ProfileService.getCurrentProfileData();

    if (Object.keys(data).length) {
      this.sidebarInfo = data;
      this.topic = urldecode(this.sidebarInfo.hopping);
    }

    this.innerScroll()
  },

  methods: {
    sendTopic(topic) {
      ProfileService.sendWhatsHopping(topic)
    },
    innerScroll() {
      if (window.innerWidth <= 740) {
        this.$root.$emit('scrollTo', '#content-view-inner')
      }
    },
    goBack() {
      //temporary
      const previous = document.referrer
      const base = process.env.VUE_APP_PROFILES_BASE_URL

      if (previous.startsWith(base) && previous.includes('home')) {
        window.history.back()
      } else {
        window.location = base + '/home.php'
      }
    },
  }
}
</script>

<style scoped lang="scss">
#loader {
  position: absolute;
  width: 100%;
  height: 60vh;
  top: 0;
  background: #f7f7f7;
}
.profile-wrapper {
  display: grid;
  grid-template-columns: 300px 1fr;
  grid-template-areas:
        "sidebar main ads"
        "sidebar main ads";
  grid-gap: 21px;

  .profile-sidebar-wrapper {
    grid-row: sidebar;
    background: #FFFFFF;
    border: 1px solid #E9E9E9;
    border-radius: 4px;
    max-height: 900px;
    margin-top: 70px;
  }

  .profile-content-wrapper {
    grid-column: main;
    grid-row: main;

    .profile-hopping {
      margin-bottom: 21px;
    }
    @media screen and (max-width: 740px) {
      .profile-hopping {
        margin-top: unset;
      }
    }
  }

  .profile-ads-wrapper {
    grid-row: ads;
  }
}
@media screen and (max-width: 740px) {
    .profile-wrapper {
      grid-template-columns: 1fr;
      grid-template-areas: "sidebar" "main";
    }
  }
</style>
